import { render } from "./CampoSenha.vue?vue&type=template&id=09cd012a&ts=true"
import script from "./CampoSenha.vue?vue&type=script&lang=ts"
export * from "./CampoSenha.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__